import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../Config';
import { useAuth } from '../contexts/AuthContext';
import Swal from 'sweetalert2';
import { Printer, CheckCircle, ArrowRight } from 'lucide-react';

export default function VerificarContrato() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { token } = useAuth();
    const [htmlContent, setHtmlContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPreview = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/socio/${id}/contrato/preview`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Error al cargar contrato');
                const text = await response.text();
                setHtmlContent(text);
            } catch (error) {
                console.error(error);
                Swal.fire('Error', 'No se pudo cargar la vista previa del contrato', 'error');
            } finally {
                setLoading(false);
            }
        };

        fetchPreview();
    }, [id, token]);

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    const handleContinue = () => {
        navigate(`/socios/${id}/confirmar-firma`);
    };

    if (loading) return <div className="text-center py-12"><div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto"></div></div>;

    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-5xl mx-auto">
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">Verificar Solicitud de Ingreso</h1>
                        <p className="text-sm text-gray-500 mt-1">Revise los datos, imprima la solicitud y confirme la operación.</p>
                    </div>
                    <div className="flex gap-3">
                        <button
                            onClick={handlePrint}
                            className="inline-flex items-center px-4 py-2 border border-blue-600 shadow-sm text-sm font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            <Printer className="w-5 h-5 mr-2" />
                            Imprimir Solicitud
                        </button>
                        <button
                            onClick={handleContinue}
                            className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                        >
                            Confirmar Solicitud
                            <CheckCircle className="w-5 h-5 ml-2" />
                        </button>
                    </div>
                </div>

                <div className="bg-white p-8 shadow-lg rounded-lg border border-gray-200 min-h-[600px] overflow-auto">
                    {/* Renderizar HTML de forma segura (asumiendo que viene sanitizado del backend o es de confianza) */}
                    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                </div>
            </div>
        </div>
    );
}
